/* Extension auth callback: shows success/failure after token generation. Auto-closes the tab. */

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { KiwiIcon } from "@/components/brand/KiwiIcon";

export function ExtensionAuthCallbackPage() {
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const name = searchParams.get("name");

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        window.close();
      } catch {
        // Ignore - tab may not be closable
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!token) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="bg-card rounded-2xl p-8 max-w-md w-full text-center border border-border">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mb-6">
            <svg
              className="w-8 h-8 text-destructive"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-foreground mb-2">
            Authorization Failed
          </h1>
          <p className="text-muted-foreground">
            Something went wrong. Please try signing in again from the
            extension.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl p-8 max-w-md w-full text-center border border-border">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
          <KiwiIcon className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-xl font-semibold text-foreground mb-2">
          Extension Authorized!
        </h1>
        <p className="text-muted-foreground mb-4">
          {name ? `Welcome, ${name}!` : "Welcome!"} Your browser extension is
          now connected to FeedKiwi.
        </p>
        <p className="text-muted-foreground/70 text-sm">
          {email && <span className="block mb-2">Signed in as {email}</span>}
          This tab will close automatically...
        </p>
        <button
          onClick={() => window.close()}
          className="mt-6 px-6 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors"
        >
          Close This Tab
        </button>
      </div>
    </div>
  );
}
